module.exports = __webpack_public_path__ + "img/case-kitchenaid.457c2cea.png";